import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=3075b082&scoped=true"
import script from "./submitSuccess.vue?vue&type=script&lang=js"
export * from "./submitSuccess.vue?vue&type=script&lang=js"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=3075b082&prod&lang=less"
import style1 from "./submitSuccess.vue?vue&type=style&index=1&id=3075b082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3075b082",
  null
  
)

export default component.exports